import { StateUtils } from '@spartacus/core';
import {
  B2BPermissionOrderListItem,
  DeliveryAddress,
  ListModel,
  Permission,
  PermissionConnectionTypeEnum,
  PermissionConnections,
  PermissionOrdersSearchParams,
  SearchConfig,
  ShipToFilterParams,
  SimpleCustomer,
  SoldTo,
} from '../../../../core/model';
import { PyStateUtils } from '../../../../core/state/utils';
import { serializeSearchConfig } from '../../../../core/state/utils/serializer';
import {
  PERMISSION_CONNECTIONS_LIST,
  PERMISSION_CONNECTIONS_UPDATE,
  PERMISSION_CONTACT_PERSON,
  PERMISSION_CREATE,
  PERMISSION_DELETE,
  PERMISSION_ENTITIES,
  PERMISSION_FILTER_SHIPTOS_ENTITIES,
  PERMISSION_FILTER_SHIPTOS_LIST,
  PERMISSION_FILTER_SOLDTOS_ENTITIES,
  PERMISSION_FILTER_SOLDTOS_LIST,
  PERMISSION_LIST,
  PERMISSION_ORDERS_ENTITIES,
  PERMISSION_ORDERS_LIST,
  PERMISSION_PUBLISH,
  PERMISSION_UNPUBLISH,
} from '../permission-state';

export const LOAD_PERMISSION = '[Permission] Load Permission Data';
export const LOAD_PERMISSION_FAIL = '[Permission] Load Permission Data Fail';
export const LOAD_PERMISSION_SUCCESS = '[Permission] Load Permission Data Success';

export const LOAD_PERMISSIONS = '[Permission] Load Permissions';
export const LOAD_PERMISSIONS_FAIL = '[Permission] Load Permissions Fail';
export const LOAD_PERMISSIONS_SUCCESS = '[Permission] Load Permissions Success';

export const LOAD_PERMISSION_ORDERS = '[Permission] Load Permission orders';
export const LOAD_PERMISSION_ORDERS_FAIL = '[Permission] Load Permission orders Fail';
export const LOAD_PERMISSION_ORDERS_SUCCESS = '[Permission] Load Permission orders Success';
export const LOAD_PERMISSION_ORDER_SUCCESS = '[Permission] Load Permission order Success';

export const LOAD_PERMISSION_FILTER_SOLDTOS = '[Permission] Load Permission filters soldtos';
export const LOAD_PERMISSION_FILTER_SOLDTOS_SUCCESS = '[Permission] Load Permission filters soldtos Success';
export const LOAD_PERMISSION_FILTER_SOLDTO_SUCCESS = '[Permission] Load Permission filters soldto Success';
export const LOAD_PERMISSION_FILTER_SOLDTOS_FAIL = '[Permission] Load Permission filters soldtos Fail';
export const RESET_FILTER_SOLD_TOS = '[Permission] Reset Filter SoldTos';

export const LOAD_PERMISSION_FILTER_SHIPTOS = '[Permission] Load Permission filters shiptos';
export const LOAD_PERMISSION_FILTER_SHIPTOS_SUCCESS = '[Permission] Load Permission filters shiptos Success';
export const LOAD_PERMISSION_FILTER_SHIPTO_SUCCESS = '[Permission] Load Permission filters shipto Success';
export const LOAD_PERMISSION_FILTER_SHIPTOS_FAIL = '[Permission] Load Permission filters shiptos Fail';

export const CREATE_PERMISSION = '[Permission] Create Permission';
export const CREATE_PERMISSION_FAIL = '[Permission] Create Permission Fail';
export const CREATE_PERMISSION_SUCCESS = '[Permission] Create Permission Success';

export const RESET_CREATE_PERMISSION = '[Permission] Reset Permission Create';
export const RESET_DELETE_PERMISSION = '[Permission] Reset Permission delete';
export const RESET_PERMISSION_CONNECTIONS = '[Permission] Reset permission connections';
export const RESET_PERMISSION_ORDERS = '[Permission] Reset permission orders';

export const UPDATE_PERMISSION = '[Permission] Update Permission';
export const UPDATE_PERMISSION_FAIL = '[Permission] Update Permission Fail';
export const UPDATE_PERMISSION_SUCCESS = '[Permission] Update Permission Success';

export const UPDATE_CONTACT_PERSON = '[Permission] Update ContactPerson';
export const UPDATE_CONTACT_PERSON_FAIL = '[Permission] Update ContactPerson Fail';
export const UPDATE_CONTACT_PERSON_SUCCESS = '[Permission] Update ContactPerson Success';

export const LOAD_PERMISSION_CONNECTIONS = '[Permission] Load permission connections';
export const LOAD_PERMISSION_CONNECTIONS_FAIL = '[Permission] Load permission connections Fail';
export const LOAD_PERMISSION_CONNECTIONS_SUCCESS = '[Permission] Load permission connections Success';

export const UPDATE_PERMISSION_CONNECTIONS = '[Permission] Update permission connections';
export const UPDATE_PERMISSION_CONNECTIONS_FAIL = '[Permission] Update permission connections Fail';
export const UPDATE_PERMISSION_CONNECTIONS_SUCCESS = '[Permission] Update permission connections Success';

export const PUBLISH_PERMISSION = '[Permission] Publish';
export const PUBLISH_PERMISSION_FAIL = '[Permission] Publish Fail';
export const PUBLISH_PERMISSION_SUCCESS = '[Permission] Publish Success';

export const UNPUBLISH_PERMISSION = '[Permission] Unpublish';
export const UNPUBLISH_PERMISSION_FAIL = '[Permission] Unpublish Fail';
export const UNPUBLISH_PERMISSION_SUCCESS = '[Permission] Unpublish Success';

export const DELETE_PERMISSION = '[Permission] Delete Permission';
export const DELETE_PERMISSION_FAIL = '[Permission] Delete Permission Fail';
export const DELETE_PERMISSION_SUCCESS = '[Permission] Delete Permission Success';

export class LoadPermission extends StateUtils.EntityLoadAction {
  readonly type = LOAD_PERMISSION;
  constructor(public payload: { userId: string; permissionCode: string }) {
    super(PERMISSION_ENTITIES, payload.permissionCode);
  }
}

export class LoadPermissionFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_PERMISSION_FAIL;
  constructor(public payload: { permissionCode: string; error: any }) {
    super(PERMISSION_ENTITIES, payload.permissionCode, payload.error);
  }
}

export class LoadPermissionSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSION_SUCCESS;
  constructor(public payload: Permission | Permission[]) {
    super(PERMISSION_ENTITIES, Array.isArray(payload) ? payload.map((permission) => permission?.code) : payload?.code);
  }
}

export class LoadPermissionOrderSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSION_ORDER_SUCCESS;
  constructor(public payload: B2BPermissionOrderListItem | B2BPermissionOrderListItem[]) {
    super(
      PERMISSION_ORDERS_ENTITIES,
      Array.isArray(payload) ? payload.map((permissionOrderList) => permissionOrderList?.orderNumber) : payload?.orderNumber
    );
  }
}

export class LoadPermissions extends StateUtils.EntityLoadAction {
  readonly type = LOAD_PERMISSIONS;
  constructor(
    public payload: {
      userId: string;
      params: SearchConfig;
    }
  ) {
    super(PERMISSION_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadPermissionsFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_PERMISSIONS_FAIL;
  constructor(public payload: { params: SearchConfig; error: any }) {
    super(PERMISSION_LIST, serializeSearchConfig(payload.params), payload.error);
  }
}

export class LoadPermissionsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSIONS_SUCCESS;
  constructor(
    public payload: {
      page: ListModel;
      params: SearchConfig;
    }
  ) {
    super(PERMISSION_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadPermissionOrders extends StateUtils.EntityLoadAction {
  readonly type = LOAD_PERMISSION_ORDERS;
  constructor(
    public payload: {
      userId: string;
      params: PermissionOrdersSearchParams;
      permissionCode: string;
    }
  ) {
    super(PERMISSION_ORDERS_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadPermissionOrdersFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_PERMISSION_ORDERS_FAIL;
  constructor(public payload: { params: PermissionOrdersSearchParams; error: any }) {
    super(PERMISSION_ORDERS_LIST, serializeSearchConfig(payload.params), payload);
  }
}

export class LoadPermissionOrdersSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSION_ORDERS_SUCCESS;
  constructor(
    public payload: {
      page: ListModel;
      params: PermissionOrdersSearchParams;
    }
  ) {
    super(PERMISSION_ORDERS_LIST, serializeSearchConfig(payload.params));
  }
}
export class LoadPermissionFilterSoldTos extends StateUtils.EntityLoadAction {
  readonly type = LOAD_PERMISSION_FILTER_SOLDTOS;
  constructor(
    public payload: {
      userId: string;
      params: ShipToFilterParams;
    }
  ) {
    super(PERMISSION_FILTER_SOLDTOS_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadPermissionFilterSoldTosFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_PERMISSION_FILTER_SOLDTOS_FAIL;
  constructor(public payload: { params: ShipToFilterParams; error: any }) {
    super(PERMISSION_FILTER_SOLDTOS_LIST, serializeSearchConfig(payload.params), payload);
  }
}

export class LoadPermissionFilterSoldTosSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSION_FILTER_SOLDTOS_SUCCESS;
  constructor(
    public payload: {
      page: ListModel;
      params: ShipToFilterParams;
    }
  ) {
    super(PERMISSION_FILTER_SOLDTOS_LIST, serializeSearchConfig(payload.params));
  }
}

export class ResetFilterSoldTos extends StateUtils.LoaderResetAction {
  readonly type = RESET_FILTER_SOLD_TOS;
  constructor() {
    super(PERMISSION_FILTER_SOLDTOS_LIST);
  }
}

export class LoadPermissionFilterShipTos extends StateUtils.EntityLoadAction {
  readonly type = LOAD_PERMISSION_FILTER_SHIPTOS;
  constructor(
    public payload: {
      userId: string;
      params: ShipToFilterParams;
    }
  ) {
    super(PERMISSION_FILTER_SHIPTOS_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadPermissionFilterShipTosFail extends PyStateUtils.EntityFailAction {
  readonly type = LOAD_PERMISSION_FILTER_SHIPTOS_FAIL;
  constructor(public payload: { params: ShipToFilterParams; error: any }) {
    super(PERMISSION_FILTER_SHIPTOS_LIST, serializeSearchConfig(payload.params), payload);
  }
}

export class LoadPermissionFilterShipTosSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSION_FILTER_SHIPTOS_SUCCESS;
  constructor(
    public payload: {
      page: ListModel;
      params: ShipToFilterParams;
    }
  ) {
    super(PERMISSION_FILTER_SHIPTOS_LIST, serializeSearchConfig(payload.params));
  }
}

export class LoadPermissionFilterShipToSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSION_FILTER_SHIPTO_SUCCESS;
  constructor(public payload: DeliveryAddress | DeliveryAddress[]) {
    super(
      PERMISSION_FILTER_SHIPTOS_ENTITIES,
      Array.isArray(payload) ? payload.map((deliveryAddress) => deliveryAddress?.id) : payload?.id
    );
  }
}

export class LoadPermissionFilterSoldToSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_PERMISSION_FILTER_SOLDTO_SUCCESS;
  constructor(public payload: SoldTo | SoldTo[]) {
    super(PERMISSION_FILTER_SOLDTOS_ENTITIES, Array.isArray(payload) ? payload.map((soldTo) => soldTo?.uid) : payload?.uid);
  }
}

export class CreatePermission extends StateUtils.EntityLoadAction {
  readonly type = CREATE_PERMISSION;
  constructor(public payload: { userId: string; permission: Permission }) {
    super(PERMISSION_CREATE, payload.permission.code);
  }
}

export class CreatePermissionFail extends PyStateUtils.EntityFailAction {
  readonly type = CREATE_PERMISSION_FAIL;
  constructor(public payload: { permissionCode: string; error: any }) {
    super(PERMISSION_CREATE, payload.permissionCode, payload.error);
  }
}

export class CreatePermissionSuccess extends StateUtils.EntitySuccessAction {
  readonly type = CREATE_PERMISSION_SUCCESS;
  constructor(public payload: Permission) {
    super(PERMISSION_CREATE, payload.code, payload);
  }
}

export class ResetCreatePermission implements StateUtils.LoaderAction {
  readonly type = RESET_CREATE_PERMISSION;
  constructor() {}
}

export class ResetDeletePermission implements StateUtils.LoaderAction {
  readonly type = RESET_DELETE_PERMISSION;
  constructor() {}
}

export class ResetPermissionConnections implements StateUtils.LoaderAction {
  readonly type = RESET_PERMISSION_CONNECTIONS;
  constructor() {}
}

export class ResetPermissionOrders implements StateUtils.LoaderAction {
  readonly type = RESET_PERMISSION_ORDERS;
  constructor() {}
}

export class UpdatePermission extends StateUtils.EntityLoadAction {
  readonly type = UPDATE_PERMISSION;
  constructor(
    public payload: {
      userId: string;
      permissionCode: string;
      permission: Permission;
    }
  ) {
    super(PERMISSION_ENTITIES, payload.permission.code);
  }
}

export class UpdatePermissionFail extends PyStateUtils.EntityFailAction {
  readonly type = UPDATE_PERMISSION_FAIL;
  constructor(public payload: { permissionCode: string; error: any }) {
    super(PERMISSION_ENTITIES, payload.permissionCode, payload.error);
  }
}

export class UpdatePermissionSuccess extends StateUtils.EntitySuccessAction {
  readonly type = UPDATE_PERMISSION_SUCCESS;
  constructor(public payload: Permission) {
    super(PERMISSION_ENTITIES, payload.code, payload);
  }
}

export class LoadPermissionConnections extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_PERMISSION_CONNECTIONS;
  constructor(
    public payload: {
      userId: string;
      permissionCode: string;
      connectionType: PermissionConnectionTypeEnum;
    }
  ) {
    super(PERMISSION_CONNECTIONS_LIST);
  }
}

export class LoadPermissionConnectionsFail extends PyStateUtils.LoaderFailAction {
  readonly type = LOAD_PERMISSION_CONNECTIONS_FAIL;
  constructor(public payload: any) {
    super(PERMISSION_CONNECTIONS_LIST, payload);
  }
}

export class LoadPermissionConnectionsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_PERMISSION_CONNECTIONS_SUCCESS;
  constructor(public payload: any) {
    super(PERMISSION_CONNECTIONS_LIST);
  }
}

export class UpdatePermissionConnections extends StateUtils.LoaderLoadAction {
  readonly type = UPDATE_PERMISSION_CONNECTIONS;
  constructor(
    public payload: {
      connectionType: PermissionConnectionTypeEnum;
      userId: string;
      permissionCode: string;
      connections: PermissionConnections;
    }
  ) {
    super(PERMISSION_CONNECTIONS_UPDATE);
  }
}

export class UpdatePermissionConnectionsFail extends PyStateUtils.LoaderFailAction {
  readonly type = UPDATE_PERMISSION_CONNECTIONS_FAIL;
  constructor(public payload: any) {
    super(PERMISSION_CONNECTIONS_UPDATE, payload);
  }
}

export class UpdatePermissionConnectionsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = UPDATE_PERMISSION_CONNECTIONS_SUCCESS;
  constructor(public payload: PermissionConnections) {
    super(PERMISSION_CONNECTIONS_UPDATE);
  }
}

export class UpdateContactPerson extends StateUtils.LoaderLoadAction {
  readonly type = UPDATE_CONTACT_PERSON;
  constructor(
    public payload: {
      userId: string;
      permissionCode: string;
      contactPerson: SimpleCustomer;
    }
  ) {
    super(PERMISSION_CONTACT_PERSON);
  }
}

export class UpdateContactPersonFail extends PyStateUtils.LoaderFailAction {
  readonly type = UPDATE_CONTACT_PERSON_FAIL;
  constructor(public payload: any) {
    super(PERMISSION_CONTACT_PERSON, payload);
  }
}

export class UpdateContactPersonSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = UPDATE_CONTACT_PERSON_SUCCESS;
  constructor(public payload: SimpleCustomer) {
    super(PERMISSION_CONTACT_PERSON);
  }
}

export class PublishPermission extends StateUtils.LoaderLoadAction {
  readonly type = PUBLISH_PERMISSION;
  constructor(
    public payload: {
      userId: string;
      permissionCode: string;
    }
  ) {
    super(PERMISSION_PUBLISH);
  }
}

export class PublishPermissionFail extends PyStateUtils.LoaderFailAction {
  readonly type = PUBLISH_PERMISSION_FAIL;
  constructor(public payload: any) {
    super(PERMISSION_PUBLISH, payload);
  }
}

export class PublishPermissionSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = PUBLISH_PERMISSION_SUCCESS;
  constructor(public payload: Permission) {
    super(PERMISSION_PUBLISH);
  }
}

export class UnpublishPermission extends StateUtils.LoaderLoadAction {
  readonly type = UNPUBLISH_PERMISSION;
  constructor(
    public payload: {
      userId: string;
      permissionCode: string;
    }
  ) {
    super(PERMISSION_UNPUBLISH);
  }
}

export class UnpublishPermissionFail extends PyStateUtils.LoaderFailAction {
  readonly type = UNPUBLISH_PERMISSION_FAIL;
  constructor(public payload: any) {
    super(PERMISSION_UNPUBLISH, payload);
  }
}

export class UnpublishPermissionSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = UNPUBLISH_PERMISSION_SUCCESS;
  constructor(public payload: Permission) {
    super(PERMISSION_UNPUBLISH);
  }
}

export class DeletePermission extends StateUtils.LoaderLoadAction {
  readonly type = DELETE_PERMISSION;
  constructor(
    public payload: {
      userId: string;
      permissionCode: string;
    }
  ) {
    super(PERMISSION_DELETE);
  }
}

export class DeletePermissionSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = DELETE_PERMISSION_SUCCESS;
  constructor(public payload: string) {
    super(PERMISSION_DELETE);
  }
}

export class DeletePermissionFail extends PyStateUtils.LoaderFailAction {
  readonly type = DELETE_PERMISSION_FAIL;
  constructor(public payload: any) {
    super(PERMISSION_DELETE, payload);
  }
}

export type PermissionAction =
  | LoadPermission
  | LoadPermissionFail
  | LoadPermissionSuccess
  | LoadPermissions
  | LoadPermissionsFail
  | LoadPermissionsSuccess
  | CreatePermission
  | CreatePermissionFail
  | CreatePermissionSuccess
  | ResetCreatePermission
  | ResetDeletePermission
  | UpdatePermission
  | UpdateContactPerson
  | UpdateContactPersonFail
  | UpdateContactPersonSuccess
  | UpdatePermissionFail
  | UpdatePermissionSuccess
  | ResetPermissionConnections;
